import React from 'react';
import variables from '../../../utils/variables';
import * as PropTypes from 'prop-types';
import logo1 from '../../../assets/interChainAssets/logo1.svg';
import logo2 from '../../../assets/interChainAssets/logo2.svg';
import logo3 from '../../../assets/interChainAssets/logo3.svg';
import background from '../../../assets/interChainAssets/background.svg';
import backgroundMini from '../../../assets/interChainAssets/background_mini.svg';
import './index.css';

const InterChainAssets = (props) => {
    return (
        <section className="inter_chain">
            <div className="heading">
                <h2>{variables[props.lang]['inter_chain_assets']}</h2>
                <span/>
                <p>{variables[props.lang]['inter_chain_assets_info']}</p>
            </div>
            <div className="row">
                <img alt="background" className="background" src={background}/>
                <img alt="background" className="background mobile_image" src={backgroundMini}/>
                <div className="card">
                    <img
                        alt={variables[props.lang]['inter_chain_assets_heading1']}
                        src={logo1}/>
                    <h2>{variables[props.lang]['inter_chain_assets_heading1']}</h2>
                    <p>{variables[props.lang]['inter_chain_assets_text1']}</p>
                </div>
                <div className="card">
                    <img
                        alt={variables[props.lang]['inter_chain_assets_heading2']}
                        src={logo2}/>
                    <h2>{variables[props.lang]['inter_chain_assets_heading2']}</h2>
                    <p>{variables[props.lang]['inter_chain_assets_text2']}</p>
                </div>
                <div className="card">
                    <img
                        alt={variables[props.lang]['inter_chain_assets_heading3']}
                        src={logo3}/>
                    <h2>{variables[props.lang]['inter_chain_assets_heading3']}</h2>
                    <p>{variables[props.lang]['inter_chain_assets_text3']}</p>
                </div>
            </div>
        </section>
    );
};

InterChainAssets.propTypes = {
    lang: PropTypes.string.isRequired,
};

export default InterChainAssets;
